<template>
  <div id="dialer_settings" class="flex flex-col gap-6 text_color">
    <div class="flex flex-row justify-between items-center">
      <h1 class="text-xl font-semibold primary_color">Dialer Settings</h1>
    </div>

    <div
      v-for="(config, settingKey) in dialerSettingsConfig"
      :key="settingKey"
      class="flex flex-row items-start gap-4 w-full max-w-[375px]"
    >
      <a-switch
        size="small"
        class="mt-1"
        :checked="dialerSettings[settingKey]"
        @change="(checked) => toggleSetting(settingKey, checked)"
        :loading="loadingStates[settingKey]"
      />

      <div class="flex flex-col gap-1">
        <span class="text-base font-semibold">{{ config.title }}</span>
        <span class="text-[14px] font-normal secondary_color">
          {{ config.description }}
        </span>
      </div>
    </div>

    <div class="w-full max-w-[375px]">
      <RingtoneSelector />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { message } from "ant-design-vue";
import { dialerSettingsConfig } from "@/src/constants/callConstants.js";
import store from "@/src/store/index.js";
import RingtoneSelector from "@/src/views/calls/dialer_settings/RingtoneSelector.vue";

const loadingStates = ref({});

const dialerSettings = computed(() => store.getters["dialerSettings/allSettings"]);

const initializeLoadingStates = () => {
  const loading = {};
  Object.keys(dialerSettingsConfig).forEach((key) => {
    loading[key] = false;
  });
  return loading;
};

loadingStates.value = initializeLoadingStates();

const toggleSetting = async (settingKey, newValue) => {
  const previousValue = dialerSettings.value[settingKey];
  
  try {
    if (!settingKey) {
      console.error("Setting key is required");
      return;
    }

    loadingStates.value[settingKey] = true;

    const response = await store.dispatch("dialerSettings/updateSetting", {
      key: settingKey,
      value: newValue,
    });

    if (response?.success) {
      message.success(`Setting ${newValue ? "enabled" : "disabled"} successfully`);
    } else {
      store.commit("dialerSettings/SET_SINGLE_SETTING", {
        key: settingKey,
        value: previousValue,
      });
      message.error("Failed to update setting. Please try again.");
    }
  } catch (error) {
    console.error("Error updating setting:", error);
    store.commit("dialerSettings/SET_SINGLE_SETTING", {
      key: settingKey,
      value: previousValue,
    });
    message.error("An error occurred while updating the setting.");
  } finally {
    loadingStates.value[settingKey] = false;
  }
};

</script>
